module.exports = __webpack_public_path__ + "img/candles_normal@2x.c097fe6d.svg";